import React from 'react';

export default function MpIFrame(props) {
    
    return (
        <iframe         
                //style={{display:'none'}}                
                ref={ e => props.setContainer(e)}
                title='MP Frame'
                src='http://localhost:8080/Web/sample/mpviewer/'
                width='600px' height='600px'        
                scrolling='no' frameBorder='0'                       
            />
    )    
}